"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { CAPITALES, IMG } from "@/lib/diwline-data";
import { Globe2, MapPin } from "lucide-react";

export function ExportMondial() {
  const ref = useRef<HTMLElement>(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      id="export"
      className="relative overflow-hidden py-24 md:py-32"
      aria-label="Or du Sénégal aux Quatre Coins"
    >
      <motion.div style={{ y }} className="absolute inset-0 -z-10 scale-125">
        <img
          src={`${IMG}/export-mondial.jpg`}
          alt="Carte dorée des exportations DIW'LINE à travers le monde"
          loading="lazy"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-royal/82" />
        <div className="absolute inset-0 bg-gradient-to-b from-royal via-transparent to-royal" />
      </motion.div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Reveal>
            <p className="font-elegant text-sm uppercase tracking-[0.5em] text-gold/85">✦ Or du Sénégal aux Quatre Coins ✦</p>
            <h2 className="mt-5 font-display text-3xl md:text-5xl font-semibold text-gold-gradient animate-shimmer">
              Nos Ambassades Commerciales
            </h2>
            <p className="mx-auto mt-5 max-w-3xl text-sm md:text-base leading-relaxed text-cream/80">
              Les huiles royales DIW&apos;LINE rayonnent à travers l&apos;Afrique, l&apos;Oummah et le
              monde entier. Nos ambassades commerciales portent l&apos;excellence sénégalaise dans
              les capitales les plus prestigieuses.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {CAPITALES.map((c, i) => (
            <Reveal key={c.ville} delay={(i % 4) * 0.06}>
              <div className="group flex h-full items-center gap-3 rounded-sm border border-gold/18 bg-royal/75 p-4 backdrop-blur-sm transition-all hover:border-gold/55 hover:bg-royal/90">
                <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-royal transition-colors group-hover:bg-gold/15">
                  <MapPin className="h-4.5 w-4.5 text-gold" aria-hidden />
                </span>
                <div>
                  <p className="font-display text-[15px] font-semibold text-cream group-hover:text-gold-light">
                    {c.ville}
                  </p>
                  <p className="text-[11px] leading-snug text-cream/60">{c.region}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 text-center">
          <a
            href="#contact"
            className="inline-flex min-h-12 items-center gap-3 rounded-sm border border-gold/60 px-8 py-3 text-sm font-semibold uppercase tracking-[0.22em] text-gold transition-colors hover:bg-gold hover:text-royal"
          >
            <Globe2 className="h-4.5 w-4.5" aria-hidden />
            Devenir ambassadeur DIW&apos;LINE
          </a>
        </Reveal>
      </div>
    </section>
  );
}
